<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список пользователей</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать пользователя</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Клиент</div>
            <v-select class="select"
                v-model="picked_client"
                :items="clients"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Группа<sup class="color-red">*</sup></div>
            <v-select class="select"
                v-model="group_id"
                :items="groups"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Логин <sup class="color-red">*</sup></label>
            <input type="text" class="form-control" placeholder="..." v-model="login">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">
                Электронная почта
                <sup class="color-red">*</sup>
            </label>
            <input type="text" class="form-control" placeholder="..." v-model="email">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Номер телефона</label>
            <input type="text" class="form-control" placeholder="..." v-model="mobile_phone">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Имя пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="name">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Фамилия пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="surname">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Отчество пользователя</label>
            <input type="text" class="form-control" placeholder="..." v-model="patronymic">
        </div>

        <div class="mb-4">
            <div class="form-label">Комментарий</div>
            <textarea id="admin-comment" rows="3" class="form-control" placeholder="..." v-model="comment"></textarea>
        </div>
    </div>
    <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updateUser"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>

import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import AdminUser from "../../../../models/AdminUser";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "AdminUsersEditComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_admin_groups: String,
        route_update: String,
        route_get: String,
        route_client_search: String,
        user_id: {
            type: [Number, String],
            default: 0
        }
    },
    data: function () {
        return {
            adminUser: new AdminUser({
                route_client_search: this.route_client_search,
                route_update: this.route_update,
                route_get: this.route_get,
                route_admin_groups: this.route_admin_groups,
            }),
            clients: [],
            picked_client: undefined,
            item: {},
            groups: [],
            group_id: 0,
            login: '',
            email: '',
            mobile_phone: '',
            surname: '',
            name: '',
            patronymic: '',
            comment: '',
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        itemGet: async function () {
            this.item = await this.adminUser.get(this.user_id);
            this.group_id = this.item.group_id;
            this.login = this.item.login;
            this.email = this.item.email;
            this.mobile_phone = this.item.mobile_phone;
            this.surname = this.item.surname;
            this.name = this.item.name;
            this.patronymic = this.item.patronymic;
            this.comment = this.item.comment;
            this.picked_client = this.item.client_id
        },
        updateUser: async function () {
            if (this.email === '' || this.email === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Заполните поле электронная почта!' });
                this.toggleLoading();
                return;
            }

            if (this.group_id === '' || this.group_id === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберете группу!' });
                this.toggleLoading();
                return;
            }

            if (this.login === '' || this.login === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Заполните поле логин!' });
                this.toggleLoading();
                return;
            }

            const response = await axios.post(this.route_update, {
                group_id: this.group_id,
                login: this.login,
                email: this.email,
                mobile_phone: this.mobile_phone,
                surname: this.surname,
                name: this.name,
                patronymic: this.patronymic,
                comment: this.comment,
                client_id: this.picked_client,
                id: this.user_id
            }).then((response) => {
                return response.data
            });

            if (response.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.message });
                this.toggleLoading();
                return;
            }

            window.location.href = this.route_back;
        },
        searchClients: async function () {
            let clients = await this.adminUser.clients();
            this.clients = clients.items;
        },
        searchGroups: async function() {
            let groups = await this.adminUser.getAdminGroups();
            this.groups = groups.items;
        },
    },
    mounted() {
        this.itemGet();
        this.searchClients();
        this.searchGroups();
    }
}
</script>

<style scoped>

</style>
